import { render, staticRenderFns } from "./CBSTaxes.vue?vue&type=template&id=e59b4ee8&"
import script from "./CBSTaxes.vue?vue&type=script&lang=js&"
export * from "./CBSTaxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports